import api from 'app/api';
import store from 'app/store';

const getCities = async (callback) => {
  const successCallback = ({ data }) => {
    const cities = data.map((city) => ({
      id: city._id,
      label: city.cityName,
    }))

    store.dispatch({ type: 'CITIES_LIST:DATA:SET', data: cities });

    if (callback) callback(data);
  };

  await api.get('/venues/city', {
    id: 'get-cities',
    success: {
      callback: successCallback,
    },
  });
};

const getAllEvents = async (location, callback) => {
  const successCallback = ({ data }) => {
    const secondaryEvents = (data?.resaleEvents || [])?.map((event) => ({ ...event?.payload, id: event?._id, isPrimary: false }));
    const primaryEvents = (data?.primaryEvents || []).map((event) => ({ ...event?.payload, id: event?._id, isPrimary: true }));
    const events = [...primaryEvents, ...secondaryEvents];
    events.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
    store.dispatch({
      type: 'ALL_EVENTS:SET',
      data: {
        allEvents: events,
        primaryEvents,
        secondaryEvents,
      },
    });

    if (callback) callback(data);
  };

  await api.get('/events/search', {
    id: 'post-event-filters',
    success: {
      callback: successCallback,
    },
    params: {
      location,
    },
  });
};

const getEventsList = async (city, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({
      type: 'TRENDING_EVENT_FILTERS:SET',
      data: (data?.resaleEvents || [])?.map((event) => ({ ...event?.payload, id: event?._id, _id: event?._id  })),
    });

    store.dispatch({
      type: 'PRIMARY_TRENDING_EVENTS:SET',
      data: (data?.primaryEvents || []).map((event) => ({ ...event?.payload, id: event?._id, _id: event?._id })),
    });

    if (callback) callback(data);
  };

  await api.get('/events/search', {
    id: 'get-events-list-landing',
    success: {
      callback: successCallback,
    },
    params: {
      location: city,
      isTrending: true,
      limit: 5,
    },
  });
};

const requestEvent = async (url, type, callback) => {
  const payload = {
    url: url,
    type: type,
  };

  const successCallback = ({ data }) => {
    // console.log("Response Data:", data);
    if (callback) callback(data);
  };

  await api.post('/events/request', payload, {
    id: 'request-event',
    success: {
      callback: successCallback,
    },
  });
};

const fetchCities = () => {
  return new Promise((resolve, reject) => {
    getCities((data) => {
      if (data) resolve(data);
      else reject(new Error("Failed to fetch cities"));
    });
  });
};

const searchEvents = async (searchText, location, callback, params = {}, universal) => {
  const city = JSON.parse(localStorage.getItem('selectedCity') || '{}');
  // const cities = await fetchCities();
  // const cityLabels = cities.map(city => city.cityName);
  // const formatListForQuery = (list) => list.map(item => `"${item}"`).join(' || ');
  // const formattedQuery = universal ? formatListForQuery(cityLabels) : city?.label;
  const formattedQuery = city?.label;
  
  await api.get('/events/search', {
    id: 'search-events',
    success: {
      callback: ({ data }) => {
        if (Array.isArray(data)) callback(data);
        else {
          const secondaryEvents = (data?.resaleEvents || []).map(event => ({ ...event?.payload, id: event?._id, isPrimary: false }));
          const primaryEvents = (data?.primaryEvents || []).map(event => ({ ...event?.payload, id: event?._id, isPrimary: true }));
          const events = [...primaryEvents, ...secondaryEvents];
          events.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
          if (callback) callback(events);
        }
      }
    },
    params: { searchText, location: formattedQuery || '', ...params },
  });
};


export{
  getCities,
  requestEvent,
  searchEvents,
  getAllEvents,
  getEventsList,
}

